export const HISTORY_LIMIT_PAGE = 50;
export const HISTORY_LIMIT_ELSE = 10;
